import { useTranslation } from 'react-i18next'

import { FormBuilderItemConfigMap, FormBuilderItemConfigObjectMap, FormItemType } from '../constants/form-builder.constants'
import { FormBuilderConfig } from '../types/form-builder.types'

export const builderComponentConfigFactory = (itemType: FormItemType): any => {
  return FormBuilderItemConfigMap[itemType]
}

export const builderComponentConfigObjectFactory = (itemType: FormItemType, itemConfigProps?: FormBuilderConfig): any => {
  const { t } = useTranslation()

  return FormBuilderItemConfigObjectMap(t, itemConfigProps)[itemType]
}
